import {
  Cell,
  CellLink,
  CellLinkList,
  CellList,
} from "@/directory/DirectoryTable/Cells";
import formatDate from "@/utils/formatDate";
import getAuthProviderName from "@/utils/getAuthProviderName/getAuthProviderName";

export const PAGE_SIZE = 10;

export const FILTER_UI_PROPS = {
  id: "studentsFilters",
  searchFieldLabel: "Search by name",
  searchFieldPlaceholder: "Start typing...",
  title: "Filter students",
  triggerButtonLabel: "Filter students",
};

export const COLUMNS = [
  {
    accessor: "last_name",
    Header: "Student name",
    Cell: (cell) => (
      <CellLink
        value={`${cell.cell.row.original.user.last_name}, ${cell.cell.row.original.user.first_name}`}
        href={`/account/students/${cell.cell.row.original.unique_id}/`}
      />
    ),
  },
  {
    accessor: "last_login",
    Header: "Last login",
    Cell: (cell) => {
      const lastLogin = cell.cell.row.original.user.last_login;
      return (
        <Cell
          cell={{
            ...cell,
            value: lastLogin
              ? formatDate(new Date(lastLogin), "mm/dd/yyyy")
              : "",
          }}
        />
      );
    },
  },
  {
    accessor: "username",
    Header: "Username",
    disableSortBy: true,
    Cell: (cell) => (
      <Cell cell={{ ...cell, value: cell.cell.row.original.user.username }} />
    ),
  },
  {
    accessor: "classes",
    Header: "Classes",
    disableSortBy: true,
    Cell: (cell) => (
      <CellLinkList
        value={cell.value.map((classroom) => classroom.class)}
        label="classes"
        href={`/account/students/${cell.cell.row.original.unique_id}/?tab=classes`}
      />
    ),
  },
  {
    accessor: "schools",
    Header: "Schools",
    disableSortBy: true,
    Cell: (cell) => (
      <CellList
        values={cell.value.map(({ school }) => school)}
        label="schools"
      />
    ),
  },
  {
    accessor: "last_login_method",
    Header: "Login method",
    Cell: (cell) => (
      <Cell
        cell={{
          ...cell,
          value: getAuthProviderName(
            cell.cell.row.original.user.last_login_method,
          ),
        }}
      />
    ),
  },
  {
    accessor: "status",
    Header: "Status",
    disableSortBy: true,
    Cell: (cell) => (
      <Cell
        cell={{
          ...cell,
          value: cell.cell.row.original.user.status ? "Active" : "Inactive",
        }}
      />
    ),
  },
];
